module.exports = __webpack_public_path__ + "static/media/inund_guide.drawio.39304699.svg";